
function init() {

    const taxonomyPeopleTitle = document.querySelector('.taxonomy-people-title');

    if(!taxonomyPeopleTitle) return;
    const link = taxonomyPeopleTitle.querySelector('a');
    const linkText = link.textContent;
    const pTag = document.createElement('h4');

    pTag.textContent = linkText;
    taxonomyPeopleTitle.insertBefore(pTag, link);
    taxonomyPeopleTitle.removeChild(link);

}
export { init as default };

